"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClassNames = void 0;
const predicates_1 = require("./predicates");
function isValidClassName(x) {
    return (0, predicates_1.isNonEmpty)(x) && x !== false;
}
/**
 * Joins all given class names as one string, filtering undefined/null/empty class names.
 *
 * @param args list of class name
 * @returns all class names as string.
 */
function getClassNames(...args) {
    return args.filter(isValidClassName).join(' ');
}
exports.getClassNames = getClassNames;
//# sourceMappingURL=react.js.map